import Link from "next/link";
import {footerMenuList, socialIcons} from "../data/footer_data";
import Logo from "../public/images/software-talks@2x.png";
import WhiteLogo from "../public/images/software-talks-dark@2x.png";
import Image from "next/image";

const footer = () => {
  return (
    <>
      <footer className="dark:bg-jacarta-800 page-footer bg-white">
        <div className="container">
          <div className="grid grid-cols-6 gap-x-7 gap-y-14 pt-10 pb-10 md:grid-cols-12">
            <div className="col-span-3 md:col-span-4">
              {/* <!-- Logo --> */}
              <div className="dark:hidden">
                <Link href="/">
                  <a className="mb-6 inline-block">
                    <Image
                      src={Logo}
                      height={50}
                      width={169}
                      alt="Software Talks"
                      className="max-h-7 h-auto "
                    />
                  </a>
                </Link>
              </div>
              <div className="hidden dark:block">
                <Link href="/">
                  <a className="mb-6 inline-block">
                    <Image
                      src={WhiteLogo}
                      height={50}
                      width={169}
                      alt="Software Talks"
                      className="max-h-7 h-auto "
                    />
                  </a>
                </Link>
              </div>


              <p className="dark:text-jacarta-300 mb-12">
                The best selection of Software Tech Conferences. An accurate list of conferences where you can enjoy and learn from the best Speakers.
              </p>

              {/* <!-- Socials --> */}
              <div className="flex space-x-5">
                {socialIcons.map((item) => {
                  const {id, href, text} = item;
                  return (
                    <Link href={href} key={id}>
                      <a
                        target="_blank"
                        rel="noopener noreferrer"
                        className="group cursor-pointer"
                      >
                        <svg className="icon group-hover:fill-accent fill-jacarta-300 h-5 w-5 dark:group-hover:fill-white">
                          <use xlinkHref={`/icons.svg#icon-${text}`}></use>
                        </svg>
                      </a>
                    </Link>
                  );
                })}
              </div>
            </div>

            <div
              className="col-span-full sm:col-span-1 md:col-span-4"

            ></div>
            <div
              className="col-span-full sm:col-span-3 text-right md:col-span-2"
            ></div>

            {footerMenuList.map((single) => (
              <div
                className={`col-span-full sm:col-span-3 text-right md:col-span-2 ${single.diffClass}`}
                key={single.id}
              >
                <h3 className="font-display text-jacarta-700 mb-6 text-sm dark:text-white">
                  {single.title}
                </h3>
                <ul className="dark:text-jacarta-300 flex flex-col space-y-1">
                  {single.list.map((item) => {
                    const {id, href, text} = item;
                    return (
                      <li key={id}>
                        <Link href={href}>
                          <a className="hover:text-accent dark:hover:text-white">
                            {text}
                          </a>
                        </Link>
                      </li>
                    );
                  })}
                </ul>
              </div>
            ))}
          </div>

          <div className="flex flex-col items-center justify-between space-y-2 py-8 sm:flex-row sm:space-y-0">
            <span className="dark:text-jacarta-400 text-sm">
              <span>© {new Date().getFullYear()} Software Talks. All rights reserved.</span>
            </span>

            <ul className="dark:text-jacarta-400 flex flex-wrap space-x-4 text-sm">
              <li>
                <Link href="/terms-of-use">
                  <a className="hover:text-accent dark:hover:text-white">
                    Terms of Use
                  </a>
                </Link>
              </li>
              <li>
                <Link href="/privacy">
                  <a className="hover:text-accent dark:hover:text-white">
                    Privacy policy
                  </a>
                </Link>
              </li>
            </ul>
          </div>
        </div>
      </footer>
    </>
  );
};

export default footer;
